import axios from 'axios'

const API_URL = process.env.REACT_APP_BACKEND_API + 'ai/generatetz'

export const generateTask = async body => {
  const { data } = await axios.post(API_URL, body, { withCredentials: true })
  return data
}
